import { LayoutGenerator } from "./utils/layoutGenerator"
import { Text } from "materials/text/menus/model"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
import { Tabs } from "materials/tabs/menus/model"
import { Pagination } from "materials/pagination/menus/model"

/**
 * 门户手风琴默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["accordionComponentPlugin"],
    encId: "0",
    changeWayType: 0,
    background: [
      {
        color: "#FFFFFF",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        isShow: true,
        height: 100,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 0,
            options: new Tabs({
              left: 0,
              top: 53,
              singleTabs: false
            })
          },
          {
            innerElement: "cxText",
            isActive: false,
            isShow: true,
            elementInLayoutId: 3,
            options: new Text({
              left: 0,
              top: 10,
              content: "手风琴图文"
            })
          },
        ]
      },
      {
        type: "bottom",
        isShow: true,
        height: 80,
        elementOptions: [
          {
            innerElement: "cxButton",
            isActive: false,
            isShow: true,
            type: "more",
            elementInLayoutId: 1,
            options: new Button({
              leftType: "%",
              topType: "%",
              left: 50,
              top: 50,
              margin: ["-50%", 0, 0, "-50%"],
              content: "更多",
            })
          },
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: false,
            type: "pagination",
            elementInLayoutId: 2,
            options: new Pagination({})
          }
        ]
      },
      {
        type: "left",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      },
      {
        type: "right",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          openIndex: 0,
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [],
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "40%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 3,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 4,
                          content: "偏微分方程",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 6,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 7,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ],
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 8,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 9,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 10,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 11,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 12,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 13,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 14,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 15,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 16,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 17,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 18,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 19,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 20,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 21,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 22,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          height: "100%",
          openIndex: 0,
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [],
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "40%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 23,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 24,
                          content: "偏微分方程",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 25,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 26,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 27,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ],
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 28,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 29,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 30,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 31,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 32,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 33,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 34,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 35,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 36,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 37,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 38,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 39,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 40,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 41,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 42,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          height: "100%",
          openIndex: 0,
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [],
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "40%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 43,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 44,
                          content: "偏微分方程",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 45,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 46,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 47,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ],
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 48,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 49,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 50,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 51,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 52,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 53,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 54,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 55,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 56,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 57,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    },{
                      width: "20%",
                      elementOptions: [
                        new Image({
                          elementInLayoutId: 58,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderBottomLeftRadius: 10,
                          widthType: "%",
                          width: 40,
                          heightType: "%",
                          height: 100,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 59,
                          content: "普通天文学",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 50,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 5,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 60,
                          content: "本课程力求实事求是地刻画偏微分方程这门学科产生的历史源头问题以及在当今世界的实用性，不仅选编了历史上著名的案例，还选编了现实感较强的案例进行分析，让同学们不仅感受到这门课程的理论价值，还希望能让读者感受这门学科的时代感和她所具有的社会的、现实的价值。因此，本课程可作为高等院校本科生“偏微分方程”、“数学物理方程”的在线学习课程，也可作为理工科和经济管理学科本科生、研究生的在线学习课程。",
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: 22,
                          color: "#535353",
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 4,
                          widthType: "%",
                          width: 50,
                          height: 90,
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 20,
                          isOpenState: true
                        }),
                        new Button({
                          elementInLayoutId: 61,
                          width: 80,
                          height: 20,
                          content: "查看详情",
                          bgColor: "#fff",
                          color: "rgba(43,103,255,1)",
                          fontWeight: 400,
                          borderWidth: [0,0,0,0],
                          leftType: "%",
                          topType: "%",
                          left: 45,
                          top: 80,
                          isOpenState: true
                        }),
                        new Image({
                          elementInLayoutId: 62,
                          top: 0,
                          left: 0,
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                          borderBottomLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          widthType: "%",
                          width: 100,
                          heightType: "%",
                          height: 100,
                          isOpenState: false
                        }),
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]
    }).rows
  },
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["accordionComponentPlugin"],
    encId: "1",
    changeWayType: 0,
    accordionType: "vertical", //竖向手风琴图文标志
    background: [
      {
        color: "#FFFFFF",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        isShow: true,
        height: 100,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 0,
            options: new Tabs({
              left: 0,
              top: 53,
              singleTabs: false,
              tabsList: [{ name: "默认", content: "默认" },],
            })
          },
          {
            innerElement: "cxText",
            isActive: false,
            isShow: true,
            elementInLayoutId: 3,
            options: new Text({
              left: 0,
              top: 10,
              content: "手风琴图文"
            })
          },
        ]
      },
      {
        type: "bottom",
        isShow: true,
        height: 80,
        elementOptions: [
          {
            innerElement: "cxButton",
            isActive: false,
            isShow: true,
            type: "more",
            elementInLayoutId: 1,
            options: new Button({
              leftType: "%",
              topType: "%",
              left: 50,
              top: 50,
              margin: ["-50%", 0, 0, "-50%"],
              content: "更多",
            })
          },
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: false,
            type: "pagination",
            elementInLayoutId: 2,
            options: new Pagination({})
          }
        ]
      },
      {
        type: "left",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      },
      {
        type: "right",
        isShow: false,
        width: 120,
        height: 400,
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          openIndex: 0,
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [],
              rows: [
                {
                  height: "30%",
                  cols: [
                    {
                      width: "100%",
                      elementOptions: [
                        new Text({
                          elementInLayoutId: 4,
                          content: "30",
                          fontSize: 44,
                          fontWeight: 600,
                          widthType: "%",
                          width: 6,
                          heightType: "%",
                          height: 50,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 10,
                          lineHeight: 50,
                          textIsThemeColor: true,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 80,
                          height: 34,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 6,
                          lineHeight: 34,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 6,
                          content: "2023-07",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 6,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 60,
                          lineHeight: 20,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 7,
                          content: "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制控制控制控制",
                          fontSize: 14,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 68,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 37,
                          lineHeight: 22,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 3,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 8,
                          content: "11-17",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 5,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 28,
                          lineHeight: 20,
                          isOpenState: false
                        }),
                        new Text({
                          elementInLayoutId: 9,
                          content: "如何打通卓越工程师培养的“最后一公里”",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 26,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 23,
                          lineHeight: 26,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: false
                        }),
                      ],
                    }
                  ]
                },
                {
                  height: "17.5%",
                  cols: [
                    {
                      width: "100%",
                      elementOptions: [
                        new Text({
                          elementInLayoutId: 4,
                          content: "30",
                          fontSize: 44,
                          fontWeight: 600,
                          widthType: "%",
                          width: 6,
                          heightType: "%",
                          height: 50,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 10,
                          lineHeight: 50,
                          textIsThemeColor: true,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "如何打通卓越工程师培养的“最后一公里”",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 80,
                          height: 34,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 6,
                          lineHeight: 34,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 6,
                          content: "2023-07",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 6,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 60,
                          lineHeight: 20,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 7,
                          content: "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制控制控制控制",
                          fontSize: 14,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 68,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 37,
                          lineHeight: 22,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 3,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 8,
                          content: "11-17",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 5,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 28,
                          lineHeight: 20,
                          isOpenState: false
                        }),
                        new Text({
                          elementInLayoutId: 9,
                          content: "如何打通卓越工程师培养的“最后一公里”",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 26,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 23,
                          lineHeight: 26,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: false
                        }),
                      ],
                    }
                  ]
                },
                {
                  height: "17.5%",
                  cols: [
                    {
                      width: "100%",
                      elementOptions: [
                        new Text({
                          elementInLayoutId: 4,
                          content: "30",
                          fontSize: 44,
                          fontWeight: 600,
                          widthType: "%",
                          width: 6,
                          heightType: "%",
                          height: 50,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 10,
                          lineHeight: 50,
                          textIsThemeColor: true,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 80,
                          height: 34,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 6,
                          lineHeight: 34,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 6,
                          content: "2023-07",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 6,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 60,
                          lineHeight: 20,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 7,
                          content: "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制控制控制控制",
                          fontSize: 14,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 68,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 37,
                          lineHeight: 22,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 3,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 10,
                          content: "10-16",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 5,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 28,
                          lineHeight: 20,
                          isOpenState: false
                        }),
                        new Text({
                          elementInLayoutId: 11,
                          content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 26,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 23,
                          lineHeight: 26,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: false
                        }),
                      ],
                    }
                  ]
                },
                {
                  height: "17.5%",
                  cols: [
                    {
                      width: "100%",
                      elementOptions: [
                        new Text({
                          elementInLayoutId: 4,
                          content: "30",
                          fontSize: 44,
                          fontWeight: 600,
                          widthType: "%",
                          width: 6,
                          heightType: "%",
                          height: 50,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 10,
                          lineHeight: 50,
                          textIsThemeColor: true,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "科技赋能未来城市",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 80,
                          height: 34,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 6,
                          lineHeight: 34,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 6,
                          content: "2023-07",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 6,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 60,
                          lineHeight: 20,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 7,
                          content: "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制控制控制控制",
                          fontSize: 14,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 68,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 37,
                          lineHeight: 22,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 3,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 12,
                          content: "10-13",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 5,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 28,
                          lineHeight: 20,
                          isOpenState: false
                        }),
                        new Text({
                          elementInLayoutId: 13,
                          content: "科技赋能未来城市",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 26,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 23,
                          lineHeight: 26,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: false
                        }),
                      ],
                    }
                  ]
                },
                {
                  height: "17.5%",
                  cols: [
                    {
                      width: "100%",
                      elementOptions: [
                        new Text({
                          elementInLayoutId: 4,
                          content: "30",
                          fontSize: 44,
                          fontWeight: 600,
                          widthType: "%",
                          width: 6,
                          heightType: "%",
                          height: 50,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 10,
                          lineHeight: 50,
                          textIsThemeColor: true,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 5,
                          content: "中国空间站“天宫课堂”开新课 “第二课堂”带领青少年感受天地大不同",
                          fontSize: 18,
                          fontWeight: 600,
                          widthType: "%",
                          width: 80,
                          height: 34,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 6,
                          lineHeight: 34,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 6,
                          content: "2023-07",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 6,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 60,
                          lineHeight: 20,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 7,
                          content: "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制控制控制控制",
                          fontSize: 14,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 68,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 37,
                          lineHeight: 22,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 3,
                          isOpenState: true
                        }),
                        new Text({
                          elementInLayoutId: 14,
                          content: "09-01",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 5,
                          height: 20,
                          leftType: "%",
                          topType: "%",
                          left: 1,
                          top: 28,
                          lineHeight: 20,
                          isOpenState: false
                        }),
                        new Text({
                          elementInLayoutId: 15,
                          content: "中国空间站“天宫课堂”开新课 “第二课堂”带领青少年感受天地大不同",
                          fontSize: 16,
                          fontWeight: 400,
                          widthType: "%",
                          width: 80,
                          height: 26,
                          leftType: "%",
                          topType: "%",
                          left: 8,
                          top: 23,
                          lineHeight: 26,
                          contentHasLimit: true,
                          contentHasLimitRadio: "行数",
                          textLimitLines: 1,
                          isOpenState: false
                        }),
                      ],
                    }
                  ]
                },
              ]
            }
          ]
        },
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = []

/**
 * app手风琴默认配置数据
 */
export const appHome = [{}]
